import React from 'react';

/**
 * ComingSoon
 *
 * Full-bleed placeholder for pages that are not live yet (Matchmaker and
 * Reader's Corner). Nothing but the tagline.
 *
 * Rendered as a fixed overlay pinned to the whole viewport. The shared Navbar
 * sits at z-index 10002 (Navbar.jsx) so it paints on top of this and stays
 * usable; pinning to top: 0 rather than to a hardcoded navbar height means
 * there is no gap to keep in sync if the navbar's height ever changes.
 */

export const COMING_SOON_COLOURS = {
  ink:   '#292524',
  cream: '#F5F0E8',
  rust:  '#B85C38',
  ember: '#E8603C',
};
const SERIF = 'var(--font-display)';

export default function ComingSoon({
  headline,
  accent = COMING_SOON_COLOURS.rust,
  maxWidth = 1000,
  headlineSize = 'clamp(36px, 7.2vw, 108px)',
  lineHeight = 1.06,
}) {
  return (
    <div
      data-coming-soon="true"
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        background: `radial-gradient(120% 90% at 50% 0%, #FAF6EE 0%, ${COMING_SOON_COLOURS.cream} 60%)`,
        color: COMING_SOON_COLOURS.ink,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '80px 24px 12vh',
        overflowY: 'auto',
      }}
    >
      <div style={{ textAlign: 'center', maxWidth, width: '100%' }}>
        <div
          style={{
            fontFamily: SERIF,
            fontStyle: 'italic',
            fontSize: 'clamp(16px, 1.8vw, 24px)',
            color: accent,
          }}
        >
          coming soon.
        </div>

        <h1
          style={{
            fontFamily: SERIF,
            fontWeight: 700,
            fontSize: headlineSize,
            lineHeight,
            letterSpacing: '-0.015em',
            margin: '18px 0 0',
          }}
        >
          {headline}
        </h1>
      </div>
    </div>
  );
}
